// ===================================================
// Imports
// ===================================================
// Alpine js imports + plugins
import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus'
Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.plugin(focus);

// Alpine js init + data injects
if (document.getElementById("FindClubEducationPage")) {
  import('./findComponent').then(function (page) {
    page.findComponentData();
    Alpine.data('findComponentData', page.findComponentData); // IMPORTANT: This needs to be applied before Alpine.start()
    Alpine.start();
  });
} else {
  Alpine.start();
}

// Custom imports
import hideAdElements from './hideAdElements';

// ===================================================
// Element Variables
// ===================================================
const root = getComputedStyle(document.body);
const bodyEl = document.body as HTMLBodyElement;
const siteHeaderEl = document.querySelector('.site-header') as HTMLElement;
const pageContentEl = document.querySelector('.page-content') as HTMLDivElement;
const primaryNavigationTopEl = document.getElementById('primaryNavigationTop');
const sectionListLinks = document.getElementsByClassName('section-list__link');
const districtListInnerElements = document.querySelectorAll(
  '.district-list__inner'
) as NodeListOf<HTMLElement>;
const eventListInnerElements = document.querySelectorAll(
  '.event-list__inner'
) as NodeListOf<HTMLElement>;
const districtToggleEl = document.querySelector(
  '.district-toggle'
) as HTMLElement;
const eventToggleEl = document.querySelector('.event-toggle') as HTMLElement;

// Hide navbar on scroll
// ===========================
const lgWidth = 1000;
let mouseOnNavbar = false;
siteHeaderEl.addEventListener('mouseenter', function () {
  mouseOnNavbar = true;
});
siteHeaderEl.addEventListener('mouseleave', function () {
  mouseOnNavbar = false;
});
var lastScrollTop: number;
setTimeout(() => {
  window.addEventListener('scroll', function () {
    if (mouseOnNavbar && this.window.innerWidth > lgWidth) return;
    if (bodyEl.classList.contains('overflow-hidden')) return;
    var translateValue = siteHeaderEl.offsetHeight;

    var scrollTop = window.scrollY;

    if (
      scrollTop > lastScrollTop &&
      scrollTop > siteHeaderEl.offsetHeight + 100
    ) {
      siteHeaderEl.style.transform = 'translateY(-' + translateValue + 'px)';
    } else {
      siteHeaderEl.style.transform = 'translateY(0)';
    }
    lastScrollTop = scrollTop;
  });
}, 100);

// Change color of Event Section Toggle 
// when on event page to match the current menu color
// ===========================================
if (bodyEl.getAttribute("data-parent") == "event") {
  // Get & check menuColor for isLightColor color
  const eventMenuColor = bodyEl.style.getPropertyValue('--bg-color');
  const eventTextColor = bodyEl.style.getPropertyValue('--text-color');
  eventToggleEl.style.backgroundColor = eventMenuColor;
  eventToggleEl.style.color = eventTextColor;
  eventToggleEl.style.fill = eventTextColor;
}

// StartPageEvent slider init
// =============================
if (bodyEl.id == "StartPageEvent") {
  const heroSectionEventEl = document.querySelector(".hero-section-event") as HTMLElement;
  if (heroSectionEventEl) {
    // Check if heroSection is splide element
    if (heroSectionEventEl?.classList.contains("splide")) {
      import('./initHeroSectionSplide').then(function (page) {
        page.initHeroSectionSplide(heroSectionEventEl);
      });
    } 

    // Variables needed to initate countdown
    const eventStartDateValue = heroSectionEventEl.getAttribute("data-startdate");
    const heroCountdown = heroSectionEventEl.querySelector(".countdown");
    if (eventStartDateValue && heroCountdown) {
      const eventStartDate = new Date(eventStartDateValue);
      import('./initCountdown').then(function (page) {
        page.initCountdown(heroSectionEventEl, eventStartDate);
      });
    }
  }
}

// // ===================================================
// Dynamic header related code
// ===================================================
// Setting top marign of .page-content to accomodate the 
// header height to prevent page content from going under fixed header
const headerHeight = (siteHeaderEl.clientHeight - 1).toString() + 'px';
if (pageContentEl != null) {
  pageContentEl.style.marginTop = headerHeight;
}

// Check if the header height has changed and if so change pageContent top margin to it
const checkHeaderHeight = () => {
  const headerHeight = (siteHeaderEl?.clientHeight - 1).toString() + 'px';
  if (pageContentEl.style.marginTop != headerHeight) {
    pageContentEl.style.marginTop = headerHeight;
  }
};
if (siteHeaderEl != null && pageContentEl != null) {
  window.onresize = checkHeaderHeight; // Run the check on resize of the browser window
}

// Function to check if desktop width and set section dropdown margins and position
const setSectionMargins = () => {
  const primaryNavigationTopElLeftDistance = (primaryNavigationTopEl?.getBoundingClientRect().left + 20).toString() + 'px';

  if (screen.width >= parseInt(root.getPropertyValue('--md-width'), 10)) {
    if (sectionListLinks != null) {
      // Set paddings for sections links
      Array.from(sectionListLinks).forEach((element) => {
        let link = element as HTMLElement;
        link.style.paddingLeft = primaryNavigationTopElLeftDistance;
      });
    }

    if (districtToggleEl != null) {
      districtToggleEl.style.paddingLeft = primaryNavigationTopElLeftDistance;
    }

    if (eventToggleEl != null) {
      eventToggleEl.style.paddingLeft = primaryNavigationTopElLeftDistance;
    }

    if (districtListInnerElements != null) {
      // Set margin for district list
      Array.from(districtListInnerElements).forEach((element) => {
        element.style.marginLeft = primaryNavigationTopElLeftDistance;
      });
    }

    if (eventListInnerElements != null) {
      // Set margin for district list
      Array.from(eventListInnerElements).forEach((element) => {
        element.style.marginLeft = primaryNavigationTopElLeftDistance;
      });
    }
  } else {
    if (sectionListLinks != null) {
      // Set margins for sections links
      Array.from(sectionListLinks).forEach((element) => {
        let link = element as HTMLElement;
        link.style.marginLeft = 'auto';
      });
    }

    if (districtListInnerElements != null) {
      // Set margin for district list
      Array.from(districtListInnerElements).forEach((element) => {
        element.style.marginLeft = 'auto';
      });
    }
  }
};

// NEWS ARCHIVE mixitup filters
// ===============================
if (document.getElementById("NewsArchive")) {
  import('./newsArchiveMixItUp').then(function (page) {
    page.newsArchiveMixItUp();
  });
};

// Window functions (onload, resize)
// ====================================
const resizeFunction = () => {
  checkHeaderHeight();
  setSectionMargins();
};
const onLoadFunction = () => {
  checkHeaderHeight();
  setSectionMargins();
  checkSideScroll();
};
window.onload = onLoadFunction;
window.onresize = resizeFunction;

// COMPETITION CALENDAR mixitup filters (klasser + grenar etc)
// =============================================================
if (document.getElementById("CompetitionCalendar")) {
  import('./mixitupQueryString').then(function (page) {
    page.mixitupQueryString();
  });
}

// SPONSOR MARQUEE - set speed etc
// =================================
const sponsorMarqueeElements = document.getElementsByClassName(
  'sponsors-marquee__wrapper'
);
if (sponsorMarqueeElements != null) {
  Array.from(sponsorMarqueeElements).forEach((element) => {
    let wrapper = element as HTMLElement;
    let sponsorGroup = wrapper.querySelector('.sponsors-marquee__group');
    let sponsors = sponsorGroup.querySelectorAll('.sponsor-item');
    // Let each sponsor take 4 seconds
    let durationValue = (sponsors.length * 4).toString() + 's';
    wrapper.style.setProperty('--duration', durationValue);
  });
}

// EVENT CALENDAR mixitup pagination
// ===================================
if (document.getElementById("EventArchive")) {
  import('./eventCalendarMixItUp').then(function (page) {
    page.eventCalendarMixItUp();
  });
}

// Nav items overflow - horizontally in desktop 
// ===============================================
const navItemsDekstopEl = document.querySelector(
  '.nav-items__1--desktop'
) as HTMLElement;
const fadeOverlayEl = document.getElementsByClassName('fade-overlay');
const forwardToggle = document.querySelector(
  '.horizontal-scroll--end'
) as HTMLElement;
const backToggle = document.querySelector(
  '.horizontal-scroll--start'
) as HTMLElement;

// Function to scroll horizontally
function sideScroll(element, direction, speed, distance, step) {
  var scrollAmount = 0;
  var slideTimer = setInterval(function () {
    if (direction == 'left') {
      element.scrollLeft -= step;
    } else {
      element.scrollLeft += step;
    }
    scrollAmount += step;
    if (scrollAmount >= distance) {
      window.clearInterval(slideTimer);
    }
    setTimeout(function () {
      if (element.scrollLeft > 0) {
        forwardToggle.classList.remove('horizontal-scroll--active');
        backToggle.classList.add('horizontal-scroll--active');
      } else {
        forwardToggle.classList.add('horizontal-scroll--active');
        backToggle.classList.remove('horizontal-scroll--active');
      }
    }, 500);
  }, speed);
}

// Function to check if nav items are overflowing
function checkSideScroll() {
  if (
    navItemsDekstopEl != undefined &&
    fadeOverlayEl != undefined &&
    navItemsDekstopEl.offsetWidth + 5 < navItemsDekstopEl.scrollWidth
  ) {
    Array.from(fadeOverlayEl).forEach((element) => {
      element.classList.add('fade-overlay--active');
    });

    forwardToggle.classList.add('horizontal-scroll--active');

    forwardToggle.onclick = function () {
      sideScroll(navItemsDekstopEl, 'right', 13, 500, 10);
    };

    backToggle.onclick = function () {
      sideScroll(navItemsDekstopEl, 'left', 13, 500, 10);
    };
  } else {
    Array.from(fadeOverlayEl).forEach((element) => {
      element.classList.remove('fade-overlay--active');
    });

    forwardToggle.classList.remove('horizontal-scroll--active');
  }
}

// Show more articles onClick
// ==============================
var articleContainer: Array<HTMLElement> = [];

if (document.getElementById('searchpage') != undefined) {
  document.getElementById('newspage-container') != undefined
    ? articleContainer.push(document.getElementById('newspage-container'))
    : null;

  document.getElementById('contentpage-container') != undefined
    ? articleContainer.push(document.getElementById('contentpage-container'))
    : null;

    if (articleContainer.length > 0) {
      // Change this value to how many should be shown initially
      var showDefaultValue = 3;
      // Change this value to how many should be loaded onClick
      var showMoreValue = 3;
    
      articleContainer.forEach((containerElement) => {
        // The inital amount of news being displayed
        if (containerElement != undefined) {
          var newsContainerChildren = containerElement.children;
          var currentIndex = 0 + showDefaultValue;
          var currentValue =
            newsContainerChildren.length > showDefaultValue
              ? showDefaultValue
              : newsContainerChildren.length;
          for (let i = 0; i < currentValue; i++) {
            const element = newsContainerChildren[i];
            element.classList.remove('hidden');
          }
        }
    
        // The onClick function loading more news
        var addNumber = currentIndex + showMoreValue;
        var showMoreNewsBtn = containerElement.nextElementSibling;
    
        if (showMoreNewsBtn != null) {
          showMoreNewsBtn.addEventListener('click', () => {
            for (let i = currentIndex; i < addNumber; i++) {
              const element = newsContainerChildren[currentIndex];
              currentIndex++;
    
              if (element != undefined && element.classList.contains('hidden')) {
                element.classList.remove('hidden');
              }
              if (addNumber >= newsContainerChildren.length) {
                showMoreNewsBtn.remove();
              }
            }
            addNumber += showMoreValue;
          });
        }
      });
    }
}

// Splide slider for competition block
// ======================================
if (document.querySelectorAll(".competitionBlock")) {
  const competitionBlocks = document.querySelectorAll(".competitionBlock");

  import('@splidejs/splide').then(function (_splide) {
    if (competitionBlocks.length > 0) {
      Array.from(competitionBlocks).forEach((block: HTMLElement) => {
        var splide = new _splide.default(block, {
          perPage: 3,
          breakpoints: {
            720: {
              perPage: 1,
              perMove: 1,
            },
          },
          perMove: 3,
          gap: '24px',
          pagination: false,
        });
      
        splide.mount();
      })
    }
  });
}

// Hide annons text if no ad is shown (due to no cookie consent for marketing)
// @ts-ignore
if (!Cookiebot.consent.marketing) {
    hideAdElements();
}